const TextCommandTypes = {
  TinyMceCommand:           'tinyMceCommand',
  VerticalAlignmentCommand: 'verticalAlignmentCommand',
  LineHeightCommand:        'lineHeightCommand',
};

const TinyMCECommandTypes            = {
  Size:                'FontSize',
  FontFamily:          'FontName',
  Bold:                'Bold',
  Italic:              'Italic',
  Underline:           'Underline',
  Color:               'forecolor',
  JustifyCenter:       'JustifyCenter',
  JustifyLeft:         'JustifyLeft',
  JustifyRight:        'JustifyRight',
  JustifyFull:         'JustifyFull',
  Subscript:           'Subscript',
  VerticalAlign:       'verticalAlign',
  Superscript:         'Superscript',
  InsertOrderedList:   'InsertOrderedList',
  InsertUnorderedList: 'InsertUnorderedList',
  LineSpacing:         'LineHeight',
};
const GUIToTinyMCECommandsDictionary = {
  FontSize:            'fontSize',
  FontName:            'fontFamily',
  forecolor:           'color',
  InsertOrderedList:   'isNumberList',
  InsertUnorderedList: 'isBulletList',
  LineHeight:          'lineSpacing',
  Bold:                'isBold',
  Italic:              'isItalic',
  Underline:           'isUnderline',
  JustifyCenter:       'isJustifyCenter',
  JustifyLeft:         'isJustifyLeft',
  JustifyRight:        'isJustifyRight',
  JustifyFull:         'isJustify',
  Subscript:           'isSubScript',
  Superscript:         'isSupperScript',
};


TextCommandTypes.Mixin = {
  created() {
    this.TextCommandTypes = TextCommandTypes;
  },
};
GUIToTinyMCECommandsDictionary.Mixin = {
  created() {
    this.GUIToTinyMCECommandsDictionary = GUIToTinyMCECommandsDictionary;
  },
};
TinyMCECommandTypes.Mixin = {
  created() {
    this.TinyMCECommandTypes = TinyMCECommandTypes;
  },
};
export { TextCommandTypes, TinyMCECommandTypes, GUIToTinyMCECommandsDictionary };
